import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Autocomplete,
  TextField,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import { dispatch } from "app/store/store";
import {
  showHideUserTimezoneModal,
  switchUserTimezone,
  updateAuthUserTimeZone,
  updateUserTimezone,
} from "app/store/slice/common-slice";

/***Temp Files** */
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { useTheme } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import SweetAlert from "./SweetAlert";
import { TIMEZONESLIST } from "app/utils/constants/genericData";
import { updateReportingFiltersTimezone } from "app/store/slice/report-slice";

const UserTimezoneModal = (props) => {
  const Swal = useSwalWrapper();
  const ToastRef = useRef();
  const theme = useTheme();
  const sweetAlerts = (variant, message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      width: "auto",
    });

    Toast.fire({
      icon: variant,
      title: message,
      background: theme.palette.background.paper,
    });
  };

  const { openUserTimezoneModal, authUserData, userTimezone } = useSelector(
    (state) => state.CommonReducer
  );

  let sel_timezone_Obj = {};
  for (var i = 0; i < TIMEZONESLIST.length; i++) {
    if (TIMEZONESLIST[i]["id"] == userTimezone) {
      sel_timezone_Obj = TIMEZONESLIST[i];
    }
  }

  const [usertimezone, setUserTimeZone] = React.useState("");
  useEffect(() => {
    setUserTimeZone(sel_timezone_Obj);
  }, [userTimezone]);

  const changeUserTimezoneHandler = (value) => {
    setUserTimeZone(value);
  };

  const applyUserTimeZoneHandler = () => {
    if (userTimezone != usertimezone.id) {
      dispatch(showHideUserTimezoneModal(false));
      dispatch(
        switchUserTimezone({
          id: authUserData.user_id,
          timezone: usertimezone.id,
        })
      )
        .then(unwrapResult)
        .then((res) => {
          if (res.data?.error == false) {
            sweetAlerts(
              "success",
              "User timezone are updated successfully",
              res.data.message
            );
            dispatch(updateUserTimezone(usertimezone.id));
            dispatch(
              updateReportingFiltersTimezone({ timezone: usertimezone.id })
            );
            dispatch(updateAuthUserTimeZone(usertimezone.id));
          } else {
            sweetAlerts("error", res.data.message);
          }
        });
    }
  };
  const closeModal = () => {
    dispatch(showHideUserTimezoneModal(false));
    setUserTimeZone(sel_timezone_Obj);
  };
  return (
    <div>
      <Dialog
        open={openUserTimezoneModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .css-nubafe-MuiPaper-root-MuiDialog-paper": {
            borderRadius: "15px",
          },
        }}
      >
        <DialogContent
          sx={{
            width: { xs: "290px", sm: "400px", md: "400px", lg: "400px" },
            pt: "40px",
            pb: "20px",
          }}
        >
          <Box>
            <Autocomplete
              clearOnEscape
              disableClearable
              id="global_user_id"
              options={TIMEZONESLIST}
              getOptionLabel={(option) => (option.name ? option.name : "")}
              sx={{
                width: "100%",
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Timezone"
                  placeholder="Select Timezone"
                />
              )}
              onChange={(event, value) => changeUserTimezoneHandler(value)}
              value={usertimezone}
            />
          </Box>

          {/* </FormControl> */}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: "30px" }}>
          <Button
            onClick={closeModal}
            variant="outlined"
            color="error"
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={applyUserTimeZoneHandler}
            //autoFocus
            variant="contained"
            color="success"
            size="small"
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <SweetAlert ref={ToastRef} />
    </div>
  );
};

export default UserTimezoneModal;
